// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2BjGH","head":"Table_head__3wIYR","col":"Table_col__3Qsb9"};